import { State, ActorRefFrom } from 'xstate';
import { ComponentMachine } from '../../component/types';
import { createComponentsMachine } from '../components';
import { ComponentTypes } from '../types';
import { checkIfComponentIsUsedForBilling } from '../utils';

export type ComponentsMachine = ReturnType<typeof createComponentsMachine>;

export type ComponentsState = State<ComponentsMachine['context']>;

type CategorizedComponents = Record<
  ComponentTypes,
  { id: number; componentMachineRef: ActorRefFrom<ComponentMachine> }[]
>;

export const getComponentsUsedInBilling = (machineState: ComponentsState) => {
  const categorizedComponents = {} as CategorizedComponents;
  const productCatalogItems = machineState.context.items;
  productCatalogItems.forEach((component) => {
    if (!checkIfComponentIsUsedForBilling(component.component)) return;
    const componentType = component.component.type;
    const categorizedComponent = {
      id: component.component.id,
      componentMachineRef: component.ref,
    };
    if (categorizedComponents.hasOwnProperty(componentType)) {
      return categorizedComponents[componentType].push(categorizedComponent);
    }
    categorizedComponents[componentType] = [categorizedComponent];
  });

  return categorizedComponents;
};
